import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getLoanOffers } from '../../apis/loan';
import { handleApiError } from '../../helpers';
import { LoanOffer, LoanOfferTabs } from '../../interfaces';
import { fetchLoanOffers } from '../../states/action_creators/loan.action_creator';

export const useFetchLoanOffers = () => {
  const dispatch = useDispatch();

  const { id, tab } = useParams<{ id: string; tab: string }>();
  const [loadingOffers, setLoading] = useState(false);
  const [offers, setOffers] = useState<null | LoanOffer[]>(null)

  const handleFetchLoanOffers = async () => {
    setLoading(true);
    try {
      const response = await getLoanOffers(+id);
      const offers: LoanOffer[] = response.data;
      setOffers(offers)
      dispatch(fetchLoanOffers(offers));
      setLoading(false);
    } catch (error) {
      toast.error(handleApiError(error));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tab === LoanOfferTabs.OFFERS) {
      handleFetchLoanOffers();
    }
  }, [tab, id, dispatch]);

  return {
    offers,
    loadingOffers,
    handleFetchLoanOffers,
  };
};
